/**
 * Responsive tables.
 *
 * Dependencies: basictable
 */

import basictable from '../vendor/basictable';

new basictable( 'table.responsive', {
	forceResponsive: false,
} );
